// Checkbox (drawing v2.6, screen 2, row Checkbox): a 20 by 20 box, radius 4,
// inside a 44 by 44 tap area; on is a navy fill with a white check. The
// label is part of the tap.

import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import { Check } from "lucide-react";
import { cx } from "./cx";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "className"> {
  /** The visible label, or (icon-only) the aria-label. */
  label: ReactNode;
  hideLabel?: boolean;
  className?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox({ label, hideLabel, className, disabled, ...rest }, ref) {
  return (
    <label className={cx("pg-ck__row", className)}>
      <span className={cx("pg-ck", disabled && "is-disabled")}>
        <input ref={ref} type="checkbox" disabled={disabled} aria-label={hideLabel && typeof label === "string" ? label : undefined} {...rest} />
        <i>
          <Check className="pg-ico pg-ico--s" aria-hidden />
        </i>
      </span>
      {!hideLabel && <span>{label}</span>}
    </label>
  );
});
